import {useActions, useGetters, useMutators, useState} from './_default';
export default {
    namespaced: true,
    state: {
        ...useState(),
        expanded: true,
        disabled: false,
    },
    getters: {
        ...useGetters(),
        expanded: state => state.expanded,
        disabled: state => state.disabled,
    },
    mutations: {
        ...useMutators(),
        expanded(state, status) {
            state.expanded = status;
        },

        disabled(state, status) {
            state.disabled = status;
        },
    },
    actions: {
        ...useActions(),
    },
}
